<template>
  <v-timeline dense>
    <v-timeline-item
      v-for="(item, i) in items"
      :key="i"
      :color="item.color"
      :icon="item.icon"
      fill-dot
    >
      <v-card :color="item.color" dark>
        <v-card-text class="pa-2 white--text" style="font-size:1rem;">{{item.text}}</v-card-text>        
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>
<script>
export default {
  data: () => ({
    items: [
      {
        color: "grey darken-2",
        icon: "mdi-star",
        text: "Fill application form"
      },
      {
        color: "grey darken-2",
        icon: "mdi-book-variant",
        text:"Submit form with documents"
      },
      {
        color: "grey darken-2",
        icon: "mdi-airballoon",
        text:"Await approval"
      },
      {
        color: "grey darken-2",
        icon: "mdi-buffer",
        text:"Collect accreditation card"
      },
    ],
  }),
};
</script>